export default "__VITE_ASSET__CsrvFHUM__"